import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { httpClient } from '../../common/httpclient';
import { MobileOpenCash } from '../../component/cashregister/MobileCashRegisters';
import { useAppBarTitle } from '../../component/layout/AppBarActions';
import PageScaffold from '../../component/pageScaffold/PageScaffold';
import usePermissions from '../../hooks/usePermissions';
import useIsMobileShell from '../../hooks/useIsMobileShell';
import { useOpenCash } from './components/useCashActions';

// `/cashregisters/open/:id` deixou de ser uma página de página cheia — a
// ação "Abrir caixa" agora é um modal central real (`OpenCashModal`, §5.6),
// acionado a partir do menu dropdown da Lista de caixas e do header do
// Painel do caixa (ver FRONTEND-TASKS.md, item "Abrir caixa"). Acessar esta
// rota diretamente (ex.: link salvo/digitado à mão) só redireciona para o
// Painel do caixa, mesmo precedente de `pages/categories/Form.js` para rotas
// de ação que viraram modal/drawer embutido em outra tela.
//
// Shell mobile: a rota volta a ser uma página cheia (`caixas/abrir.html`),
// com a mesma regra/endpoint do modal (`useOpenCash`).
function MobileOpenPage({ id }) {
    const navigate = useNavigate();
    const { userData } = usePermissions();
    const [name, setName] = useState('');
    const [snack, setSnack] = useState({ open: false, message: '' });
    useAppBarTitle('Abrir caixa');

    useEffect(() => {
        let active = true;
        httpClient.get(`/cashregister/${id}`).then((response) => {
            if (active && response.status === 200) setName(response.data?.name || '');
        }).catch(() => {});
        return () => { active = false; };
    }, [id]);

    const backToPanel = (state) => navigate(`/cashregisters/view/${id}`, { replace: true, state });
    const { amount, obs, setObs, amountError, saving, changeAmount, confirm } = useOpenCash({
        open: true,
        cashRegister: { id, name },
        onSuccess: () => backToPanel({ toast: `Caixa "${name}" aberto com sucesso.` }),
        onError: (data) => setSnack({
            open: true,
            message: typeof data === 'string' ? data : (data?.message || data?.error || 'Não foi possível concluir a operação.'),
        }),
    });

    return (
        <PageScaffold
            links={[]}
            openSnackbar={snack.open}
            setOpenSnackbar={(open) => setSnack((prev) => ({ ...prev, open }))}
            message={snack.message}
            severity="error"
        >
            <MobileOpenCash
                name={name || 'Caixa'}
                operator={userData ? (userData.name || userData.username || '') : ''}
                amount={amount}
                onAmountChange={changeAmount}
                amountError={amountError}
                obs={obs}
                onObsChange={setObs}
                saving={saving}
                onCancel={() => navigate(-1)}
                onConfirm={confirm}
            />
        </PageScaffold>
    );
}

export default function CashRegisterOpen() {
    const navigate = useNavigate();
    const { id } = useParams();
    const isMobileShell = useIsMobileShell();

    useEffect(() => {
        if (!isMobileShell) navigate(`/cashregisters/view/${id}`, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, isMobileShell]);

    return isMobileShell ? <MobileOpenPage id={id} /> : null;
}
